import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    backgroundColor: "transparent",
    marginBottom: theme.spacing(2),
    paddingLeft: 16,
  },
  tabs: {
    borderBottom: "1px solid rgba(214,214,223,0.32)",
    minHeight: 44,
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    '& .MuiTabs-flexContainer': {
      columnGap: 'clamp(20px, 3.5vw, 56px)',
    },
  },
  indicator: {
    backgroundColor: theme.text.primary,
    height: 2,
    borderRadius: 2,
  },
  tabRoot: {
    color: theme.text.subtitle,
    textTransform: "none",
    minWidth: 0,
    padding: 0,
    fontFamily: 'DM Sans',
    fontWeight: 400,
    fontStyle: 'normal',
    minHeight: 44,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '& .MuiTab-wrapper': {
      height: 26,
      lineHeight: '26px',
      display: 'inline-flex',
      alignItems: 'center',
    },
    '&.Mui-selected': {
      color: theme.text.primary,
    },
  },
  selected: {
    opacity: 1,
  },
}));

const TABS = [
  { label: "Activity", value: "activity" },
  { label: "Payment methods", value: "payment_methods" },
  { label: "Linked Accounts", value: "linked_accounts" },
  { label: "Cards", value: "cards" },
  { label: "Compliance", value: "compliance" },
  { label: "Settings", value: "settings" },
];

const CustomerSectionTabs = ({ value, onChange }) => {
  const classes = useStyles();

  const handleChange = (_, newValue) => {
    if (onChange) onChange(newValue);
  };

  return (
    <div className={classes.root}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="off"
        className={classes.tabs}
        classes={{ indicator: classes.indicator }}
      >
        {TABS.map((tab) => (
          <Tab
            key={tab.value}
            value={tab.value}
            label={tab.label}
            disableRipple
            classes={{ root: classes.tabRoot, selected: classes.selected }}
          />
        ))}
      </Tabs>
    </div>
  );
};

export default CustomerSectionTabs;


